import type { SVGProps } from "react";

export default function SolarUserSpeakRoundedLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" {...props}><g fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="10" cy="6" r="4"/><ellipse cx="10" cy="17" rx="7" ry="4"/><path strokeLinecap="round" d="M19 2C19 2 21 3.2 21 6C21 8.8 19 10 19 10"/><path strokeLinecap="round" d="M17 4C17 4 18 4.6 18 6C18 7.4 17 8 17 8"/></g></svg>
  );
}
